import { Injectable } from '@angular/core';
import { MyAssetsStatusFilter } from '@models/my-assets.model';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_STATUS_FILTER: MyAssetsStatusFilter = {
  active: true,
  inactive: false,
  suspended: true,
  device_no_line: true
};

@Injectable({
  providedIn: 'root'
})
export class MyAssetsFilterStateService {
  private _status_filter: MyAssetsStatusFilter = { ...DEFAULT_STATUS_FILTER };
  private _status_filter_subject: BehaviorSubject<MyAssetsStatusFilter>;

  constructor() {
    this._status_filter_subject = new BehaviorSubject<MyAssetsStatusFilter>(this._status_filter);
  }

  getStatusFilter(): MyAssetsStatusFilter {
    return this._status_filter;
  }

  setStatusFilter(value: Partial<MyAssetsStatusFilter>): void {
    this._status_filter = { ...this._status_filter, ...value };
    this._status_filter_subject.next(this._status_filter);
  }

  getStatusFilterSubject(): BehaviorSubject<MyAssetsStatusFilter> {
    return this._status_filter_subject;
  }

  reset(): void {
    this._status_filter = { ...DEFAULT_STATUS_FILTER };
    this._status_filter_subject.next(this._status_filter);
  }
}
